import React, { useCallback, useEffect, useRef, useState } from "react";
import logo from "../../assest/LOGO-01.webp";
import { Link, useLocation } from "react-router-dom";
import "./navbar.scss";
import { SlClose } from "react-icons/sl";
import { com, label, NavData } from "../../data/MainData";

export const Navbar = () => {
  const [navbarActive, setNavbarActive] = useState(false);
  const [headerActive, setHeaderActive] = useState(false);
  const [headerHide, setHeaderHide] = useState(false);
  const lastScrollPos = useRef(0);
  const location = useLocation();

  const closeNavbar = useCallback(() => {
    setNavbarActive(false);
  }, []);

  const toggleNavbar = () => {
    setNavbarActive((isActive) => !isActive);
  };

  useEffect(() => {
    document.body.classList.toggle("nav-active", navbarActive);
    return () => document.body.classList.remove("nav-active");
  }, [navbarActive]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setHeaderActive(currentScrollPos >= 50);
      setHeaderHide(currentScrollPos >= 50 && currentScrollPos > lastScrollPos.current);
      lastScrollPos.current = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    closeNavbar();

    if (location.hash) {
      const targetId = decodeURIComponent(location.hash.slice(1));
      requestAnimationFrame(() => {
        document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" });
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash, closeNavbar]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") closeNavbar();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [closeNavbar]);

  return (
    <header className={`header${headerActive ? " active" : ""}${headerHide ? " hide" : ""}`} data-header>
      <div className="container">
        <Link to="/" className="logo" aria-label="Abilasha Wickramarathna home">
          <img src={logo} width="100" alt="Abilasha Wickramarathna" />
        </Link>

        <nav
          id="main-navigation"
          className={`navbar ${navbarActive ? "active" : ""}`}
          data-navbar
          aria-label="Main navigation"
        >
          <button className="close-btn" type="button" aria-label="Close menu" onClick={closeNavbar}>
            <SlClose aria-hidden="true" />
          </button>

          <Link to="/" className="logo" aria-label="Abilasha Wickramarathna home" onClick={closeNavbar}>
            <img src={logo} width="150" height="50" alt="" />
          </Link>

          <ul className="navbar-list">
            {NavData.map((item) => (
              <li className="navbar-item" key={item.id}>
                <Link to={item.url} className="navbar-link hover-underline" onClick={closeNavbar}>
                  <span className="separator" aria-hidden="true"></span>
                  <span className="span">{item.heading}</span>
                </Link>
              </li>
            ))}
          </ul>

          <div className="text-center">
            <p className="headline-1 f-white">{label.labe1}</p>
            <br />
            <a href="mailto:abilasha@abiwic.com" className="body-4 contact-number hover-underline">{com.mail}</a>
            <a href="mailto:abiwickramarathna@icloud.com" className="body-4 contact-number hover-underline">{com.mail2}</a>
            <div className="separator"></div>
            <p className="headline-1 f-white">{label.label2}</p>
            <br />
            <a href="tel:+94768309969" className="body-4 contact-number hover-underline">{com.tel}</a>
            <div className="separator"></div>
            <p className="headline-1 f-white">{label.label3}</p>
            <br />
            <span className="body-4 contact-number">{com.location}</span>
          </div>
        </nav>

        <Link to="/#contact" className="btn btn-secondary">
          <span className="text text-1">Send A Mail</span>
          <span className="text text-2" aria-hidden="true">Send A Mail</span>
        </Link>

        <button
          className="nav-open-btn"
          type="button"
          aria-label={navbarActive ? "Close menu" : "Open menu"}
          aria-controls="main-navigation"
          aria-expanded={navbarActive}
          onClick={toggleNavbar}
        >
          <span className="line line-1"></span>
          <span className="line line-2"></span>
          <span className="line line-3"></span>
        </button>

        <button
          className={`overlay ${navbarActive ? "active" : ""}`}
          type="button"
          aria-label="Close navigation menu"
          tabIndex={navbarActive ? 0 : -1}
          onClick={closeNavbar}
        />
      </div>
    </header>
  );
};

export default Navbar;
